<template>
  <div>
    <BackToTopButton />
    <Header :fixed="true" models="007" />
    <div class="usp-main">
      <div class="usp-banner aniScreen">
        <div class="usp-banner-top">
          <div class="usp-banner-title"></div>
          <div class="usp-banner-btns">
            <a href="./drive.html?type=007" class="usp-banner-btn bac-whie"
              >预约试驾</a
            >
            <a
              href="./optional.html?type=007"
              target="blank"
              class="usp-banner-btn banner-bottom-btn-back-whit"
              >立即定购</a
            >
          </div>
        </div>
      </div>
      <div class="usp-xiaocan" data-ani="aniGroup">
        <div
          class="usp-xiaocan-bg aniBlock-bg"
          :data-animate="
            JSON.stringify([{ start: 0, end: 100, change: [2, 1], type: 's' }])
          "
        >
          <img
            class="usp-xiaocan-bg-img pc"
            src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623140554410-web_usp_02@1x.jpg"
          />
          <img
            class="usp-xiaocan-bg-img pad"
            src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624152143966-pad_usp_02@2x.jpg"
          />
          <img
            class="usp-xiaocan-bg-img mb"
            src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624152143541-phone_usp_02@3x.jpg"
          />
        </div>
        <div class="usp-xiaocan-text">
          <div
            class="usp-xiaocan-title"
            :data-animate="
              JSON.stringify([
                { start: 0, end: 30, change: [80, 0], type: 'y' },
                { start: 0, end: 40, change: [0, 1], type: 'o' },
              ])
            "
          >
            小CAN同学，IQ晋级
          </div>
          <div
            :data-animate="
              JSON.stringify([
                { start: 20, end: 45, change: [0, 1], type: 'o' },
              ])
            "
            class="usp-xiaocan-desc aniBlock-desc"
          >
            智能语音机器人，可以连续对话，以及智能过滤非指令语句，为你完成车内80%以上的操作。
          </div>
        </div>
        <div class="usp-xiaocan-list">
          <div
            class="usp-xiaocan-item"
            :data-animate="
              JSON.stringify([
                {
                  start: 0,
                  end: 80 + 7 * index,
                  change: [333, 0],
                  type: 'y',
                },
                {
                  start: 50 + index * 7,
                  end: 80 + index * 7,
                  change: [0, 1],
                  type: 'o',
                },
              ])
            "
            :class="'aniBlock-item-' + index"
            v-for="(item, index) in list"
            :key="index"
          >
            <img class="usp-xiaocan-item-img" :src="item.img" />
            <div class="usp-xiaocan-item-text">
              <div class="usp-xiaocan-item-title">{{ item.title }}</div>
              <div class="usp-xiaocan-item-desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="usp-gif-player-box bg-w">
        <div class="usp-gif-player">
          <swiper
            ref="mySwiper"
            class="gif-swiper"
            @slideChange="onSlideChange"
            :options="{
              loop: true,
              navigation: {
                nextEl: '.gif-swiper-next',
                prevEl: '.gif-swiper-prev',
              },
            }"
          >
            <swiper-slide v-for="(item, index) in gifs" :key="index">
              <div class="gif-swiper-image">
                <video
                  preload
                  muted="muted"
                  class="usp-video"
                  webkit-playsinline
                  playsinline
                  autoplay="autoplay"
                  loop="loop"
                  :poster="item.poster"
                >
                  <source :src="item.src" type="video/mp4" />
                </video>
              </div>
            </swiper-slide>
          </swiper>
          <div class="gif-swiper-next"></div>
          <div class="gif-swiper-prev"></div>
        </div>
        <div class="gif-swiper-dots">
          <div
            class="gif-swiper-dot"
            :class="{ active: index === gifsActive }"
            v-for="(item, index) in gifs"
            :key="index"
          ></div>
        </div>
        <div class="gif-swiper-title h2-vw">{{ gifsTitle }}</div>
        <div class="gif-swiper-desc h4-vw">{{ gifsDesc }}</div>
      </div>
      <div class="usp-app-ctrl ctrl1" data-ani="aniGroup">
        <div class="usp-app-ctrl-bg-outer">
          <div class="usp-app-mask"></div>
          <div
            :data-animate="
              JSON.stringify([
                { start: 0, end: 100, change: [1.6, 1], type: 's' },
              ])
            "
            class="usp-app-ctrl-bg"
          >
            <img
              class="usp-app-ctrl-bg-img pc"
              src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623165851177-web_usp_04@1x.jpg"
              alt
            />
            <img
              class="usp-app-ctrl-bg-img pad"
              src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624160649117-pad_usp_04@2x.jpg"
              alt
            />
            <img
              class="usp-app-ctrl-bg-img mb"
              src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624160649405-phone_usp_04@3x.jpg"
              alt
            />
          </div>
        </div>
        <div
          :data-animate="
            JSON.stringify([{ start: 0, end: 60, change: [0, 1], type: 'o' }])
          "
          class="usp-app-ctrl-right"
        >
          <div class="usp-app-ctrl-title">APP智能控车</div>
          <div class="usp-app-ctrl-desc">
            可APP寻车、钥匙分享、远程OTA等，一机在手，轻松掌控，用车无忧
          </div>
          <div
            :data-animate="
              JSON.stringify([
                { start: 0, end: 60, change: [511, 0], type: 'y' },
              ])
            "
            class="usp-app-ctrl-phone"
          >
            <img
              src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623170130709-web_usp_0402@2x.png"
              alt
            />
          </div>
        </div>
      </div>
      <div class="usp-app-ctrl" data-ani="aniGroup">
        <div class="usp-app-mask"></div>
        <div
          :data-animate="
            JSON.stringify([{ start: 90, end: 100, change: [1, 0], type: 'o' }])
          "
          class="usp-app-ctrl-car-box"
        >
          <div
            :data-animate="
              JSON.stringify([
                { start: 80, end: 95, change: [1, 6.5], type: 's' },
                { start: 50, end: 80, change: [-1000, 0], type: 'x' },
              ])
            "
            class="usp-app-ctrl-car"
          >
            <div
              :data-animate="
                JSON.stringify([
                  { start: 50, end: 80, change: [0, 360 * 3], type: 'r' },
                ])
              "
              class="usp-app-ctrl-car-run run1"
            ></div>
            <div
              :data-animate="
                JSON.stringify([
                  { start: 50, end: 80, change: [0, 360 * 3], type: 'r' },
                ])
              "
              class="usp-app-ctrl-car-run run2"
            ></div>
          </div>
        </div>
        <div class="usp-app-ctrl-bg">
          <img
            class="usp-app-ctrl-bg-img pc"
            src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623173029056-web_usp_0501@1x.jpg"
            alt
          />
          <img
            class="usp-app-ctrl-bg-img pad"
            src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624160858165-pad_usp_05@2x.jpg"
            alt
          />
          <img
            class="usp-app-ctrl-bg-img mb"
            src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624160854696-phone_usp_05@3x.jpg"
            alt
          />
        </div>
        <div class="usp-app-ctrl-top">
          <div
            :data-animate="
              JSON.stringify([
                { start: 0, end: 30, change: [80, 0], type: 'y' },
                { start: 0, end: 40, change: [0, 1], type: 'o' },
              ])
            "
            class="usp-app-ctrl-title"
          >
            2919mm 超长轴距
          </div>
          <div
            :data-animate="
              JSON.stringify([
                { start: 20, end: 45, change: [0, 1], type: 'o' },
              ])
            "
            class="usp-app-ctrl-desc"
          >
            愉悦大空间
          </div>
        </div>
      </div>
      <div class="usp-app-hz-player-box" data-ani="aniGroup" data-check="100">
        <div
          :data-animate="
            JSON.stringify([{ start: 0, end: 100, change: [1, 0], type: 'f' }])
          "
          class="usp-app-hz-player-outer bg-w"
        >
          <div class="usp-app-hz-player">
            <div
              :data-animate="
                index !== hzList.length - 1
                  ? JSON.stringify([
                      {
                        start: 30 * index,
                        end: 30 * (index + 1),
                        change: [hzList.length - index, index],
                        type: 'h',
                      },
                    ])
                  : ''
              "
              class="usp-app-hz-player-item"
              v-for="(item, index) in hzList"
              :key="index"
              :style="'z-index:' + (hzList.length - index) + ';'"
            >
              <img class="inPad" :src="item.mImg" />
              <img class="pc" :src="item.img" />
            </div>
          </div>
          <div class="usp-app-hz-dots-outer-mb">
            <!-- <div class="usp-app-hz-dots-mb">
              <div
                class="usp-app-hz-dot-mb"
                :class="{ active: index === hzActive }"
                v-for="(item, index) in hzList"
                :key="index"
              ></div>
            </div>-->
            <div class="usp-app-hz-dots-outer-mb-title">{{ hzTitle }}</div>
          </div>
          <div class="usp-app-hz-dots-outer">
            <div class="usp-app-hz-dots">
              <div
                class="usp-app-hz-dot"
                :class="{ active: index === hzActive }"
                v-for="(item, index) in hzList"
                :key="index"
              >
                {{ item.title }}
              </div>
              <div class="usp-app-hz-dot-slide-bar">
                <div
                  class="usp-app-hz-dot-slider"
                  :class="'pos-' + hzActive"
                ></div>
              </div>
            </div>
          </div>
          <div class="usp-app-hz-desc">{{ hzDesc }}</div>
        </div>
      </div>
      <div class="usp-app-hz-bottom bg-w"></div>
      <div class="usp-app-map" data-ani="aniGroup">
        <div class="usp-app-map-text">
          <div
            :data-animate="
              JSON.stringify([
                { start: 0, end: 30, change: [80, 0], type: 'y' },
                { start: 0, end: 40, change: [0, 1], type: 'o' },
              ])
            "
            class="usp-app-map-title h1-vw"
          >
            NEDC 643KM
          </div>
          <div
            :data-animate="
              JSON.stringify([
                { start: 20, end: 45, change: [0, 1], type: 'o' },
              ])
            "
            class="usp-app-map-desc h3-s-vw"
          >
            跨省级续航
          </div>
        </div>
        <div class="usp-app-map-gif">
          <video
            preload
            muted="muted"
            class="usp-video pc map-video"
            webkit-playsinline
            playsinline
            poster="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20210630141007472-pc+_%3F%3F%3F%3F.png"
          >
            <source
              src="https://test-azure-community.obs.cn-south-1.myhuaweicloud.com/20210630113241%2F833f03ae33f44a78adc2b8ce9bda6e8d.mp4"
              type="video/mp4"
            />
          </video>
          <video
            preload
            muted="muted"
            class="usp-video inPad map-video"
            webkit-playsinline
            playsinline
            poster="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20210630141007828-iapd_%3F%3F%3F%3F.png"
          >
            <source
              src="https://test-azure-community.obs.cn-south-1.myhuaweicloud.com/20210629145400%2Ff6542b4d40eb42ce9b73b9677fff852a.mp4"
              type="video/mp4"
            />
          </video>
        </div>
      </div>
      <div class="usp-app-video-player bg-g">
        <div
          class="usp-app-video-player-item"
          v-for="(item, index) in videos"
          :key="index"
        >
          <div class="usp-app-video-player-item-video">
            <div
              class="usp-app-video-player-item-video-mask"
              @click="playVideo(index)"
              :class="{ hide: item.isPlay }"
            >
              <div class="play-btn"></div>
            </div>
            <div
              class="usp-app-video-player-item-video-poster"
              :class="{ hide: item.isPlayed }"
              :style="'background-image:url(' + item.poster + ');'"
            ></div>
            <video
              preload
              muted="muted"
              :class="{ hide: item.isPlay }"
              class="usp-video usp-app-video-player-item-video-img"
              webkit-playsinline
              playsinline
              loop="loop"
            >
              <source :src="item.video" type="video/mp4" />
            </video>
          </div>
          <div class="usp-app-video-player-item-data">
            <div class="usp-app-video-player-item-data-title">
              {{ item.title }}
            </div>
            <div class="usp-app-video-player-item-data-desc">
              {{ item.desc }}
            </div>
          </div>
        </div>
      </div>
      <div ref="images" class="usp-app-imgs" :class="{ active: showAni }">
        <!-- <div class="usp-app-imgs-title h1-vw ani">220V对外放电</div>
        <div class="usp-app-imgs-title-desc h3-s-vw ani">随时随地，看一场户外电影，或与家人朋友露营BBQ，对外放电功能解锁出游无限可能</div> -->
        <div class="usp-app-img-list">
          <div class="usp-app-img-list-left">
            <div class="ani delay-1">
              <img
                src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134528179-web_usp_0901@1x.jpg"
                alt
              />
            </div>
          </div>
          <div class="usp-app-img-list-right">
            <div class="usp-app-img-list-right-top">
              <div class="ani delay-2">
                <img
                  src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134527619-web_usp_0902@1x.jpg"
                  alt
                />
              </div>
              <div class="ani delay-2">
                <img
                  src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134530394-web_usp_0903@1x.jpg"
                  alt
                />
              </div>
            </div>
            <div class="usp-app-img-list-right-bottom">
              <div class="ani delay-3">
                <img
                  src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134527596-web_usp_0904@1x.jpg"
                  alt
                />
              </div>
              <div class="ani delay-4">
                <img
                  src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134527664-web_usp_0905@1x.jpg"
                  alt
                />
              </div>
              <div class="ani delay-5">
                <img
                  src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134527984-web_usp_0906@1x.jpg"
                  alt
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-btns-box">
        <div class="footer-btns">
          <a href="https://wxaurl.cn/swk62X6uV9f" class="footer-btn seemore"
            >了解更多</a
          >
          <a href="./drive.html?type=007" class="footer-btn">预约试驾</a>
        </div>
        <div class="mimicode">
          <div class="minicode-img">
            <img
              src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20211021163005483-2.jpg"
              alt
            />
          </div>
          <div class="minicode-des">手机扫码立即预定</div>
        </div>
      </div>
    </div>
    <div class="hr"></div>
    <Floor />
  </div>
</template>

<script>
import Header from "@components/Header/index-home";
import Floor from "@components/Floor/index-home";
import BackToTopButton from "@components/BackToTopButton/index.vue";
// import { Swiper, SwiperSlide } from "swiper/vue";
// import 'swiper/dist/css/swiper.css'
import {
  swiper as Swiper,
  swiperSlide as SwiperSlide,
} from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import Scheduler from "./aniConfig";
import eventBus from "@utils/eventBus";
import utils from "@utils";
export default {
  name: "usp-007",
  components: {
    Header,
    Floor,
    Swiper,
    SwiperSlide,
    BackToTopButton,
  },
  data() {
    this.lockVideo = false;
    this.updateAni = null;
    return {
      list: [
        {
          img:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623140554019-web_usp_0201@2x.png",
          title: "连续对话",
          desc: "唤醒小CAN后，60秒内免重复唤醒，可连续下达指令",
        },
        {
          img:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623140554402-web_usp_0202@2x.png",
          title: "语音智能跟随",
          desc: "谁呼唤小CAN，小CAN就听谁的，智能过滤非指令内容",
        },
        {
          img:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623140550935-web_usp_0203@2x.png",
          title: "信息界面智能跟随",
          desc:
            "谁提问小CAN，小CAN就把信息呈现给谁，信息界面根据唤醒者位置，置于屏幕左侧或右侧",
        },
      ],
      gifs: [
        {
          img:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623140554402-web_usp_0202@2x.png",
          title: "场景智驾安全系统 Scene Safety System",
          desc:
            "含自动泊车、车道变换辅助等20多项L2+自动驾驶辅助功能，出行尽在掌控",
          poster:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20210630141007467-%3F%3F%3F%3F.png",
          src:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210628102900908-ldtc.mp4",
        },
        {
          img:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623140550935-web_usp_0203@2x.png",
          title: "驾驶员疲劳预警",
          desc:
            "通过面部分析技术+神经网络算法，鉴别驾驶员精神状态，对于疲劳驾驶、注意力分散等情况即时提示，保障长途出行安全",
          poster:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20210630141011049-%3F%3F%3F%3F%3F%3F%3F%3F.png",
          src:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210628103033752-pljs.mp4",
        },
        {
          img:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623140550935-web_usp_0203@2x.png",
          title: "生命体征探测",
          desc: "车后秒级响应探测车内生命体征，避免受困，多一重智能守护",
          poster:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20210630141007845-%3F%3F%3F%3F.png",
          src:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210628103055329-smtc.mp4",
        },
      ],
      gifsActive: 0,
      gifsTitle: "",
      gifsDesc: "",
      hzList: [
        {
          mImg:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210628171106095-pad_usp_0601@2x.jpg",
          img:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210629163751813-web_usp_0601@1x.jpg",
          title: "后座照看功能",
          desc: "可在车机屏幕上实时关注后座动态，行车不牵挂，出行更安全",
        },
        {
          mImg:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210628171105873-pad_usp_0602@2x.jpg",
          img:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210629163754465-web_usp_0602@1x.jpg",
          title: "全车空气净化",
          desc:
            "HEPA级空气滤芯，双层熔喷纤维，对0.3微米的尘埃微粒的过滤效率达到99.97%，能拦截空气中的细小微粒和有害物质",
        },
        {
          mImg:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210628171105876-pad_usp_0603@2x.jpg",
          img:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210629163751813-web_usp_0603@1x.jpg",
          title: "纯铝合金底盘",
          desc:
            "赛车级 50:50 前后配比底盘、纯铝合金材质，车身更稳定更扎实，全力守护你和家人的安全",
        },
      ],
      hzActive: 0,
      hzTitle: "",
      hzDesc: "",
      videos: [
        {
          video:
            "https://test-azure-community.obs.cn-south-1.myhuaweicloud.com/20210630095627%2F75fe7aac4d3f40ff916a513dd5fb1d78.mp4",
          title: "冥想模式",
          desc: "一键躺平，在微风或细雨声中，享受独处的时空",
          isPlay: false,
          poster:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630114527261-web_usp_0801@1x.jpg",
        },
        {
          video:
            "https://test-azure-community.obs.cn-south-1.myhuaweicloud.com/20210630100548%2F5ad1f3140938430db214782e4f703764.mp4",
          title: "Vlog模式",
          desc: "车内外录制模式，不错过路上任何美好",
          isPlay: false,
          poster:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630114524207-web_usp_0802@1x.jpg",
        },
      ],
      showAni: false,
      videoIndex: 0,
    };
  },
  mounted() {
    this.changeHzItem(0);
    this.changeGif(0);
    this.initEv();
    this.setHzSize();
    utils.onImgLoading(() => {
      // this.setHzSize();
      // this.initEv();
      this.updateAni();
    });
  },
  unMounted() {},
  methods: {
    initEv() {
      //var isPlay = false;
      let screenHeight = document.querySelector(".aniScreen").clientHeight;
      let scheduler = new Scheduler(screenHeight);
      let imagesTop = this.$refs.images.offsetTop - screenHeight / 2;
      let videoEls = Array.from(document.querySelectorAll(".map-video"));
      let videoTop = document.querySelector(".usp-app-map").offsetTop;
      let scrollingElement =
        document.scrollingElement || document.documentElement;
      let itemList = Array.from(
        document.querySelectorAll(".usp-app-hz-player-item")
      );
      scheduler.init(scrollingElement.scrollTop);
      this.updateAni = function() {
        this.setHzSize();
        itemList = Array.from(
          document.querySelectorAll(".usp-app-hz-player-item")
        );
        screenHeight = document.querySelector(".aniScreen").clientHeight;
        scheduler = new Scheduler(screenHeight);
        imagesTop = this.$refs.images.offsetTop - screenHeight / 2;
        videoEls = Array.from(document.querySelectorAll(".map-video"));
        videoTop = document.querySelector(".usp-app-map").offsetTop;
        scheduler.init(scrollingElement.scrollTop);
        scheduler.update(scrollingElement.scrollTop);
      };
      window.addEventListener(
        "scroll",
        (ev) => {
          let sEl = ev.target.scrollingElement || ev.target.documentElement;
          let top = sEl.scrollTop;
          scheduler.update(top);
          this.checkAni(top, imagesTop);
          this.checkVideo(top, videoTop, screenHeight, videoEls);
        },
        false
      );
      window.addEventListener(
        "resize",
        () => {
          this.updateAni();
        },
        false
      );
      eventBus.on("changePlay", () => {
        let index = itemList.findIndex((v) => v.clientHeight !== 0);
        this.changeHzItem(index);
      });
    },
    removeEv() {
      eventBus.offs("changePlay");
    },
    checkAni(top, imagesTop) {
      if (top > imagesTop && !this.showAni) {
        this.showAni = true;
        return;
      }
      if (top <= imagesTop && this.showAni) {
        this.showAni = false;
      }
    },
    checkVideo(top, videosTop, screenHeight, videoEls) {
      //map-video
      if (!this.lockVideo && top > videosTop - screenHeight * 0.9) {
        videoEls.forEach((v) => {
          let p = v.play();
          if (p) {
            p.then((v) => v).catch((v) => v);
          }
        });
        this.lockVideo = true;
      }
    },
    onSlideChange() {
      let {
        mySwiper: { swiper },
      } = this.$refs;
      this.changeGif(swiper.realIndex);
    },
    setHzSize() {
      let el = document.querySelector(".usp-app-hz-player-box");
      let elHeight =
        el.querySelector(".usp-app-hz-player-outer").clientHeight * 3;
      el.style.cssText = `height:${elHeight}px`;
    },
    changeGif(index) {
      let item = this.gifs[index];
      this.gifsActive = index;
      this.gifsTitle = item.title;
      this.gifsDesc = item.desc;
    },
    changeHzItem(index) {
      let item = this.hzList[index];
      if (!item) return;
      this.hzActive = index;
      this.hzTitle = item.title;
      this.hzDesc = item.desc;
    },
    animateScroll(top) {
      let scroller = document.scrollingElement || document.documentElement;
      let pageY = scroller.scrollTop;
      let mY = top - pageY;
      let startTime = +new Date();
      let duration = 450; //ms
      let run = () => {
        let time = +new Date() - startTime;
        let nextTop = pageY + mY * (time / duration);
        scroller.scrollTo(0, nextTop);
        run.timer = requestAnimationFrame(run);
        if (time >= duration) {
          scroller.scrollTo(0, top);
          cancelAnimationFrame(run.timer);
          this.lockCheck = false;
        }
      };
      this.lockCheck = true;
      requestAnimationFrame(run);
    },
    playVideo(index) {
      let item = this.videos[index];
      let p;
      item.isPlayed = true;
      let el = document.querySelectorAll(
        ".usp-app-video-player-item-video-img"
      )[index];
      if (!el) return;
      if (item.isPlay) {
        p = el.pause();
        this.videos[index].isPlay = false;
      } else {
        p = el.play();
        this.videos[index].isPlay = true;
      }
      p && p.then((v) => v).catch((v) => v);
    },
  },
};
</script>
<style lang="scss">
@import "@style/base";
@import "@style/common";
.usp-banner {
  width: 100%;
  height: 100vh;
  background: setBgImg(
    "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210629163535234-web_usp_01@1x.jpg",
    cover
  );
  @include media(
    (
      $home-md: (
        background-image:
          url("https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210629163535208-pad_usp_01@2x.jpg"),
      ),
      $home-sm: (
        background-image:
          url("https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210629163534816-phone_usp_01@2x.jpg"),
      ),
    )
  );
}
.usp-main {
  img {
    pointer-events: none;
  }
  @include setThemeClass {
    .bg-w {
      background-color: getThemeVal(brandColorWhite);
    }
    .bg-g {
      background-color: getThemeVal(backgroundColorGray);
    }
  }
  .usp-banner {
    position: relative;
    .usp-banner-top {
      position: absolute;
      left: 0;
      top: 120px;
      display: flex;
      flex-direction: column;
      align-items: center;
      right: 0;
      @include media(
        (
          $home-bg: (
            transform: scale(0.8),
          ),
          $home-md: (
            transform: scale(1),
            top: 168px,
          ),
          $home-sm: (
            top: 108px,
          ),
        )
      );
      .usp-banner-title {
        width: 420px;
        height: 184px;
        background: setBgImg(
          "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20230717175925201-pad_v09_slogan.png",
          contain
        );
        @include media(
          (
            $home-bg: (
              width: 410px,
              height: 184px,
            ),
            $home-md: (
              width: 410px,
              height: 184px,
            ),
            $home-sm: (
              width: 410px,
              height: 142px,
            ),
          )
        );
      }
      .usp-banner-btns {
        display: flex;
        justify-content: space-around;
        margin-top: 30px;
        padding: 0 30px;
        @include media(
          (
            $home-sm: (
              margin-top: 30px,
              width: 100vw,
              padding: 0px 30px,
            ),
          )
        );
        @include setThemeClass {
          .usp-banner-btn {
            @include bannerButton(getThemeVal(brandColorWhite));
            font-weight: normal;
            flex: 1;
            // width: auto;
            width: 190px;
            border-radius: 50px;
            margin: 0 10px;
          }
          //a06
          .banner-bottom-btn-back-whit + .banner-bottom-btn-back-whit {
            border-radius: 50px !important;
            margin-left: 16px;
            @include media(
              (
                $home-bg: (
                  margin-left: 10px,
                ),
                $home-sm: (
                  margin-left: 12px,
                ),
              )
            );
          }
          .banner-bottom-btn-back-whit {
            border-radius: 50px !important;
            @include bannerButton(getThemeVal(navColorBlack));
            background-color: #ffffff;
            border: 1px solid #ffffff;
            color: black;
            width: 190px;
            padding: 10px 0;
            margin: 0 10px;
            font-weight: normal;

            @include setMediaOnly($size1: $home-bg, $size2: $home-md) {
              width: 190px;
            }
            @include media(
              (
                $home-bg: (),
                $home-sm: (
                  margin-left: 12px,
                ),
              )
            );
          }
          .banner-bottom-btn-back-whit:hover {
            border: 1px solid black;
          }
        }
        .usp-banner-btn + .usp-banner-btn {
          margin-left: 16px;
        }
      }
    }
  }
  @include setThemeClass {
    .usp-xiaocan {
      position: relative;
      background-color: getThemeVal(navColorBlack);
      overflow: hidden;
      .usp-xiaocan-bg {
        @include media(
          (
            $home-sm: (
              position: absolute,
              top: 0,
              left: 0,
              right: 0,
              z-index: 1,
            ),
          )
        );
        .usp-xiaocan-bg-img {
          width: 100%;
          height: auto;
        }
      }
      .usp-xiaocan-text {
        position: absolute;
        top: vw(140);
        left: 20px;
        right: 20px;
        text-align: center;
        z-index: 2;
        @include media(
          (
            $home-md: (
              top: 80px,
            ),
          )
        );
        @include setThemeClass {
          .usp-xiaocan-title {
            @include h1-s(getThemeVal(brandColorWhite), vw);
            @include media(
              (
                $home-md: (
                  font-size: 36px,
                  line-height: 48px,
                ),
                $home-sm: (
                  font-size: 28px,
                  line-height: 42px,
                ),
              )
            );
          }
          .usp-xiaocan-desc {
            margin-top: 20px;
            @include h3-s(getThemeVal(brandColorWhite), vw);
            @include media(
              (
                $home-md: (
                  margin-top: 10px,
                  font-size: 14px,
                  line-height: 30px,
                ),
              )
            );
          }
        }
      }
      .usp-xiaocan-list {
        position: absolute;
        left: 0;
        right: 0;
        bottom: vw(100);
        display: flex;
        align-items: flex-start;
        justify-content: center;
        @include media(
          (
            $home-md: (
              bottom: 60px,
            ),
            $home-sm: (
              display: block,
              position: relative,
              left: auto,
              right: auto,
              bottom: auto,
              z-index: 2,
              padding: 336px 20px 0,
            ),
          )
        );
        .usp-xiaocan-item {
          width: vw(328);
          @include media(
            (
              $home-md: (
                width: 220px,
              ),
              $home-sm: (
                width: 100%,
                padding-bottom: 40px,
              ),
            )
          );
          .usp-xiaocan-item-img {
            width: 100%;
            height: auto;
            pointer-events: none;
          }
          .usp-xiaocan-item-text {
            margin-top: 30px;
            @include media(
              (
                $home-md: (
                  margin-top: 16px,
                ),
              )
            );
            text-align: center;
            @include setThemeClass {
              .usp-xiaocan-item-title {
                font-size: vw(20);
                font-weight: bold;
                color: getThemeVal(brandColorWhite);
                line-height: 30px;
                @include media(
                  (
                    $home-md: (
                      font-size: 20px,
                      line-height: 30px,
                    ),
                  )
                );
              }
              .usp-xiaocan-item-desc {
                margin-top: 10px;
                @include h4(getThemeVal(brandColorWhite), vw);
                line-height: 1.6;
                @include media(
                  (
                    $home-md: (
                      font-size: 14px,
                      line-height: 22px,
                    ),
                  )
                );
              }
            }
          }
        }
        .usp-xiaocan-item + .usp-xiaocan-item {
          margin-left: 24px;
          @include media(
            (
              $home-sm: (
                margin-left: 0,
              ),
            )
          );
        }
      }
    }
  }
  @include setThemeClass {
    .usp-gif-player-box {
      padding: vw(100) 0 vw(100);
      @include media(
        (
          $home-md: (
            padding: 60px 0,
          ),
          $home-sm: (
            padding: 40px 0,
          ),
        )
      );
      .usp-gif-player {
        position: relative;
        margin: 0 vw(294);
        padding: 0 90px;
        box-sizing: content-box;
        @include media(
          (
            $home-md: (
              margin: 0,
              padding: 0 80px,
            ),
            $home-sm: (
              margin: 0,
              padding: 0,
            ),
          )
        );
        .gif-swiper {
          overflow: hidden;
          margin-right: vw(-1);
          margin-bottom: vw(-1);
          .gif-swiper-image {
            box-sizing: content-box;
            width: 100%;
            height: 100%;
            object-fit: cover;
            video {
              display: block;
            }
          }
        }
        .gif-swiper-prev {
          left: 0;
          background: setBgImg(
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623164314543-icon_common_arrows_24_lef_white@3x.png",
            24px 24px,
            13px center
          );
        }
        .gif-swiper-next {
          right: 0;
          background: setBgImg(
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623164317608-icon_common_arrows_24_rig_white@3x.png",
            24px 24px,
            4px center
          );
        }
        .gif-swiper-next,
        .gif-swiper-prev {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 40px;
          height: 40px;
          background-color: getThemeVal(brandColorBlackOpacity4);
          cursor: pointer;
          transition: all 0.26s $easeOutCubic;
          @include media(
            (
              $home-sm: (
                display: none,
              ),
            )
          );
        }
        .gif-swiper-next:hover,
        .gif-swiper-prev:hover {
          background-color: getThemeVal(brandColorBlackOpacity);
        }
      }
      .gif-swiper-dots {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        .gif-swiper-dot {
          width: 100px;
          height: 2px;
          background-color: getThemeVal(lineColor);
          transition: all 0.26s $easeOutCubic;
          &.active {
            background-color: getThemeVal(brandColor);
          }
        }
        .gif-swiper-dot + .gif-swiper-dot {
          margin-left: 10px;
        }
      }
      .gif-swiper-title,
      .gif-swiper-desc {
        padding: 0 20px;
        text-align: center;
      }
      .gif-swiper-title {
        margin-top: 30px;
        @include media(
          (
            $home-md: (
              font-size: 28px,
              line-height: 42px,
              margin-top: 20px,
            ),
          )
        );
      }
      .gif-swiper-desc {
        margin-top: 10px;
        @include media(
          (
            $home-md: (
              margin-top: 20px,
              font-size: 14px,
              line-height: 22px,
            ),
          )
        );
      }
    }
  }
  @include setThemeClass {
    .usp-app-ctrl {
      position: relative;
      overflow: hidden;
      @include media(
        (
          $home-sm: (
            background-color: getThemeVal(brandColorWhite),
          ),
        )
      );

      .usp-app-mask {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-image: linear-gradient(
          180deg,
          getThemeVal(brandColorBlackOpacity1) 0%,
          rgba(0, 0, 0, 0) 50%
        );
        z-index: 3;
      }
      .usp-app-ctrl-car-box {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 2;
        background: setBgImg(
          "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210625165040369-web_usp_05@1x.jpg",
          cover
        );
        @include media((
            $home-md: (
              background-image:url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630160124144-ipad_car@3x.png),
            ),
            $home-sm: (
              background-image:url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630160124129-phone_car@3x.png),
            ),
          )
        );
        .usp-app-ctrl-car {
          position: absolute;
          top: 30%;
          left: 50%;
          margin-left: vw(-725);
          width: vw(1454);
          height: vw(818);
          background: setBgImg(
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210625165040551-car007@3x.png",
            contain
          );
          @include media(
            (
              $home-md: (
                margin-left: -405px,
                width: 810px,
                height: 458px,
                top: 35%,
              ),
              $home-sm: (
                margin-left: -188px,
                width: 375px,
                height: 211px,
                top: 50%,
              ),
            )
          );
          .usp-app-ctrl-car-run {
            position: absolute;
            width: vw(198);
            height: vw(198);
            background: setBgImg(
              "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210625165039906-before@3x.png",
              contain
            );
            @include media(
              (
                $home-md: (
                  width: 111px,
                  height: 111px,
                ),
                $home-sm: (
                  width: 51px,
                  height: 51px,
                ),
              )
            );
          }
          .run1 {
            top: vw(402);
            left: vw(239);
            @include media(
              (
                $home-md: (
                  top: 227px,
                  left: 132px,
                ),
                $home-sm: (
                  top: 105px,
                  left: 62px,
                ),
              )
            );
          }
          .run2 {
            top: vw(402);
            right: vw(255);
            @include media(
              (
                $home-md: (
                  top: 227px,
                  right: 139px,
                ),
                $home-sm: (
                  top: 105px,
                  right: 65px,
                ),
              )
            );
          }
        }
      }
    }
    .usp-app-ctrl-bg-outer {
      position: relative;
    }
    .usp-app-ctrl-bg {
      .usp-app-ctrl-bg-img {
        width: 100%;
        height: auto;
      }
    }

    .usp-app-ctrl-title {
      position: relative;
      z-index: 3;
      margin-top: vw(100);
      padding: 0 20px;
      @include h1-s(getThemeVal(brandColorWhite), vw);
      @include media(
        (
          $home-md: (
            margin-top: 60px,
            font-size: 36px,
            line-height: 48px,
          ),
          $home-sm: (
            margin-top: 40px,
            font-size: 28px,
            line-height: 42px,
          ),
        )
      );
    }
    .usp-app-ctrl-desc {
      position: relative;
      z-index: 3;
      margin-top: vw(20);
      padding: 0 20px;
      @include h3-s(getThemeVal(brandColorWhite), vw);
      @include media(
        (
          $home-md: (
            margin-top: 10px,
            font-size: 14px,
            line-height: 30px,
          ),
        )
      );
    }
    .usp-app-ctrl-top {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      overflow: hidden;
      text-align: center;
      z-index: 10;
    }
    .usp-app-ctrl-right {
      position: absolute;
      width: vw(900);
      right: 0;
      top: 0;
      bottom: 0;
      overflow: hidden;
      text-align: center;
      z-index: 10;
      background-color: getThemeVal(navColorBlackOpacity2);
      @include media(
        (
          $home-md: (
            width: 52%,
          ),
          $home-sm: (
            width: 100%,
            background-color: transparent,
            position: relative,
            right: auto,
            top: auto,
            bottom: auto,
            padding-bottom: 40px,
          ),
        )
      );
      .usp-app-ctrl-phone {
        margin: 0 auto;
        margin-top: vw(60);
        width: vw(440);
        height: auto;
        display: block;
        @include media(
          (
            $home-md: (
              margin: 118px auto 0,
              width: 297px,
            ),
            $home-sm: (
              margin-top: 324px,
            ),
          )
        );
        img {
          width: 100%;
          height: auto;
        }
      }
    }
    .ctrl1 {
      overflow: hidden;
      .usp-app-ctrl-bg-outer {
        @include media(
          (
            $home-sm: (
              position: absolute,
              top: 0,
              left: 0,
              right: 0,
              z-index: 1,
            ),
          )
        );
      }
    }
  }

  @include setThemeClass {
    .usp-app-hz-player-box {
      background-color: getThemeVal(brandColorWhite);
    }
  }
  .usp-app-hz-player-box {
    position: relative;
    height: 300vh;
    .usp-app-hz-player-outer {
      position: absolute;
      left: 0;
      right: 0;
      z-index: 10;
      .usp-app-hz-player {
        position: relative;
        .usp-app-hz-player-item {
          overflow: hidden;
          img {
            width: 100%;
            height: auto;
          }
        }
        .usp-app-hz-player-item:not(:last-child) {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
        }
      }
      .usp-app-hz-dots-outer-mb {
        display: none;
        @include media(
          (
            $home-sm: (
              display: block,
            ),
          )
        );
        .usp-app-hz-dots-mb {
          margin-top: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          @include setThemeClass {
            .usp-app-hz-dot-mb {
              width: 100px;
              height: 2px;
              background-color: getThemeVal(lineColor);
              &.active {
                background-color: getThemeVal(brandColor);
              }
              & + .usp-app-hz-dot-mb {
                margin-left: 10px;
              }
            }
          }
        }
        .usp-app-hz-dots-outer-mb-title {
          font-size: 20px;
          font-weight: bold;
          line-height: 30px;
          margin-top: 20px;
          text-align: center;
        }
      }

      .usp-app-hz-dots-outer {
        display: flex;
        justify-content: center;
        @include media(
          (
            $home-sm: (
              display: none,
            ),
          )
        );
        .usp-app-hz-dots {
          position: relative;
          margin-top: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-bottom: 12px;

          @include setThemeClass {
            .usp-app-hz-dot {
              @include h3(getThemeVal(textSubtitleColor));
              font-weight: 500;
              &.active {
                color: getThemeVal(brandColorBlack);
              }
            }
            .usp-app-hz-dot + .usp-app-hz-dot {
              margin-left: 60px;
            }
            .usp-app-hz-dot-slide-bar {
              position: absolute;
              left: 0;
              width: 100%;
              bottom: 0;
              height: 2px;
              background-color: getThemeVal(lineColor);
              .usp-app-hz-dot-slider.pos-1 {
                left: 50%;
                transform: translateX(-50%);
              }
              .usp-app-hz-dot-slider.pos-2 {
                right: 0;
                left: auto;
              }
              .usp-app-hz-dot-slider {
                position: absolute;
                top: 0;
                left: 0;
                width: 120px;
                height: 2px;
                background-color: getThemeVal(brandColorBlack);
                transition: ease-in-out 0.2s all;
                @include media(
                  (
                    $home-md: (
                      width: 84px,
                    ),
                  )
                );
              }
            }
          }
        }
      }
      @include setThemeClass {
        .usp-app-hz-desc {
          padding: 0 20px;
          margin-top: 20px;
          @include h3-s(getThemeVal(brandColorBlack));
          text-align: center;
          @include media(
            (
              $home-sm: (
                margin-top: 10px,
              ),
            )
          );
        }
      }
    }
  }
  .usp-app-hz-bottom {
    padding-bottom: 64px;
    @include media(
      (
        $home-sm: (
          padding-bottom: 40px,
        ),
      )
    );
  }
  @include setThemeClass {
    .usp-app-map {
      position: relative;
      padding-bottom: vw(100);
      background-color: getThemeVal(brandColorWhite);
      @include media(
        (
          $home-md: (
            padding-top: 60px,
            padding-bottom: 60px,
            background-color: getThemeVal(backgroundColorGray),
          ),
          $home-sm: (
            padding-top: 40px,
            padding-bottom: 40px,
          ),
        )
      );
      .usp-app-map-text {
        position: absolute;
        left: 0;
        right: 0;
        top: vw(100);
        z-index: 1;
        @include media(
          (
            $home-md: (
              position: static,
              left: auto,
              right: auto,
              top: auto,
            ),
          )
        );
        .usp-app-map-title {
          text-align: center;
          @include media(
            (
              $home-md: (
                margin-bottom: 10px,
                font-size: 36px,
                line-height: 48px,
              ),
              $home-sm: (
                font-size: 28px,
                line-height: 42px,
              ),
            )
          );
        }
        .usp-app-map-desc {
          margin-top: 10px;
          margin-bottom: 40px;
          text-align: center;
          @include media(
            (
              $home-md: (
                font-size: 14px,
                line-height: 30px,
              ),
              $home-sm: (
                margin-bottom: 30px,
              ),
            )
          );
        }
      }
      .usp-app-map-gif {
        position: relative;
        width: 100%;
        height: auto;
      }
    }
  }
  .usp-app-video-player {
    padding-top: 16px;
    padding-bottom: vw(100);
    margin: 0 -8px;
    display: flex;
    align-items: flex-start;
    @include media(
      (
        $home-md: (
          padding-top: 0,
          padding-bottom: 60px,
        ),
        $home-sm: (
          display: block,
          padding-bottom: 40px,
        ),
      )
    );
    .usp-app-video-player-item + .usp-app-video-player-item {
      @include media(
        (
          $home-sm: (
            margin-top: 40px,
          ),
        )
      );
    }
    .usp-app-video-player-item {
      padding: 0 8px;
      width: 50%;
      box-sizing: border-box;
      @include media(
        (
          $home-sm: (
            width: 100%,
            display: block,
          ),
        )
      );
      .usp-app-video-player-item-video {
        position: relative;
        overflow: hidden;
        cursor: pointer;
        @include setThemeClass {
          &:hover {
            .usp-app-video-player-item-video-mask {
              background-color: getThemeVal(brandColorBlackOpacity4);
            }
            .usp-app-video-player-item-video-poster {
              transform: scale(1.1, 1.1);
              @include media(
                (
                  $home-sm: (
                    transform: none,
                  ),
                )
              );
            }
          }
        }

        .usp-app-video-player-item-video-mask {
          opacity: 1;
          &.hide {
            opacity: 0;
          }
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: transparent;
          transition: background-color 0.5s $easeOutCubic,
            opacity 0.5s $easeOutCubic;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2;
          .play-btn {
            width: 50px;
            height: 50px;
            background: setBgImg(
              "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210628182137368-web_usp_vdo@2x.png",
              contain
            );
          }
        }
        .usp-app-video-player-item-video-poster {
          &.hide {
            opacity: 0;
          }
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          z-index: 1;
          background: no-repeat center center/cover;
          transition: transform 0.5s $easeOutCubic;
        }
        .usp-app-video-player-item-video-img {
          display: block;
          width: 100%;
          height: auto;
          object-fit: cover;
          &.hide {
            transform: none;
          }
          @include media(
            (
              $home-sm: (
                height: 250px,
                display: block,
              ),
            )
          );
        }
      }
      .usp-app-video-player-item-data {
        text-align: center;
        @include setThemeClass {
          .usp-app-video-player-item-data-title {
            margin-top: vw(60);
            @include h2(getThemeVal(brandColorBlack), vw);
            @include media(
              (
                $home-md: (
                  margin-top: 30px,
                  font-size: 28px,
                  line-height: 42px,
                ),
              )
            );
          }
          .usp-app-video-player-item-data-desc {
            margin-top: vw(20);
            @include h3-s(getThemeVal(brandColorBlack), vw);
            @include media(
              (
                $home-md: (
                  margin-top: 10px,
                  font-size: 14px,
                  line-height: 30px,
                ),
              )
            );
          }
        }
      }
    }
  }
  .usp-app-imgs {
    padding: vw(100) 0;
    @include media(
      (
        $home-md: (
          padding: 60px 0,
        ),
        $home-sm: (
          padding: 40px 0,
        ),
      )
    );
    .usp-app-imgs-title {
      padding: 0 20px;
      margin-bottom: 20px;
      text-align: center;
      @include media(
        (
          $home-md: (
            margin-bottom: 10px,
            font-size: 36px,
            line-height: 48px,
          ),
          $home-sm: (
            font-size: 28px,
            line-height: 42px,
          ),
        )
      );
    }
    .usp-app-imgs-title-desc {
      margin-bottom: vw(60);
      padding: 0 20px;
      text-align: center;
      @include media(
        (
          $home-md: (
            font-size: 14px,
            line-height: 30px,
            margin-bottom: 40px,
          ),
          $home-sm: (
            margin-bottom: 30px,
          ),
        )
      );
    }
    .usp-app-img-list {
      display: flex;
      align-items: center;
      @include media(
        (
          $home-md: (
            display: block,
          ),
        )
      );
      .usp-app-img-list-left {
        width: vw(1018);
        img {
          width: 100%;
          height: auto;
          object-fit: cover;
          display: block;
        }
        @include media(
          (
            $home-md: (
              margin-bottom: 16px,
              width: 100%,
            ),
          )
        );
      }
      .usp-app-img-list-right {
        margin-left: vw(16);
        flex: 1;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          @include media(
            (
              $home-md: (
                height: auto,
              ),
            )
          );
        }
        @include media(
          (
            $home-md: (
              margin-top: 16px,
              margin-left: 0,
              width: 100%,
            ),
          )
        );

        .usp-app-img-list-right-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          @include media(
            (
              $home-sm: (
                display: block,
              ),
            )
          );
          & > div {
            flex: 1;
            height: vw(504);
            @include media(
              (
                $home-md: (
                  height: auto,
                ),
              )
            );
          }
        }
        .usp-app-img-list-right-bottom {
          margin-top: vw(16);
          display: flex;
          align-items: center;
          justify-content: space-between;
          @include media(
            (
              $home-md: (
                margin-top: 16px,
              ),
              $home-sm: (
                display: block,
                margin-left: 0,
                width: 100%,
              ),
            )
          );
          & > div {
            flex: 1;
            height: vw(498);
            @include media(
              (
                $home-md: (
                  height: auto,
                ),
              )
            );
          }
        }
        .usp-app-img-list-right-top,
        .usp-app-img-list-right-bottom {
          div + div {
            margin-left: vw(16);
            @include media(
              (
                $home-md: (
                  margin-left: 16px,
                  width: 100%,
                ),
                $home-sm: (
                  margin-left: 0,
                  margin-top: 16px,
                ),
              )
            );
          }
        }
      }
    }
    @include setThemeClass {
      .usp-app-img {
        @include lgButton(getThemeVal(brandColorBlack));
        margin: vw(100) auto 0;
        width: 420px;
        height: 60px;
        @include media(
          (
            $home-md: (
              margin-top: 60px,
              width: 350px,
              height: 44px,
            ),
            $home-sm: (
              margin: 40px 20px 0,
              width: auto,
            ),
          )
        );
      }
    }
    &.active {
      .ani {
        transform: translateY(0);
        opacity: 1;
      }
    }
    .ani {
      opacity: 0;
      transform: translateY(80px);
      transition-property: transform, opacity;
      transition-timing-function: $easeOutCubic;
      transition-duration: 260ms;
    }
    .delay-1 {
      transition-delay: 60ms;
    }
    .delay-2 {
      transition-delay: 120ms;
    }
    .delay-3 {
      transition-delay: 180ms;
    }
    .delay-4 {
      transition-delay: 240ms;
    }
    .delay-5 {
      transition-delay: 300ms;
    }
    .delay-6 {
      transition-delay: 360ms;
    }
  }
}
.inPad {
  display: none;
  @include media(
    (
      $home-md: (
        display: block,
      ),
    )
  );
}
.usp-video {
  width: 100%;
  height: 100%;
  border: 0;
  margin: 0;
  padding: 0;
  background-color: transparent;
  object-fit: cover;
}
.footer-btns-box {
  @include setThemeClass {
    text-align: center;
    margin-bottom: 100px;
    @include media(
      (
        $home-md: (
          margin-bottom: 60px,
        ),
      )
    );
    .footer-btns {
      margin: 0 auto;
      display: flex;
      width: 420px;
      @include media(
        (
          $home-sm: (
            margin-left: 20px,
            margin-right: 20px,
            width: auto,
          ),
        )
      );
    }
    .footer-btn {
      flex: 1;
      @include bannerButton(getThemeVal(brandColorBlack));
      & + .footer-btn {
        margin-left: 24px;
        @include media(
          (
            $home-sm: (
              margin-left: 16px,
            ),
          )
        );
      }
      &.seemore {
        display: none;
        @include media(
          (
            $home-sm: (
              display: flex,
            ),
          )
        );
      }
    }
    .mimicode {
      overflow: hidden;
      .minicode-img {
        width: 160px;
        height: 160px;
        margin: 0 auto;
        margin-top: 60px;
        margin-bottom: 10px;
        border-radius: 50%;
        background: #fff;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 140px;
        }
      }
      @include media(
        (
          $home-sm: (
            display: none,
          ),
        )
      );
    }
  }
}
//全屏按钮
video::-webkit-media-controls-fullscreen-button {
  display: none;
}
//播放按钮
video::-webkit-media-controls-play-button {
  display: none;
}
//进度条
video::-webkit-media-controls-timeline {
  display: none;
}
//观看的当前时间
video::-webkit-media-controls-current-time-display {
  display: none;
}
//剩余时间
video::-webkit-media-controls-time-remaining-display {
  display: none;
}
//音量按钮
video::-webkit-media-controls-mute-button {
  display: none;
}
video::-webkit-media-controls-toggle-closed-captions-button {
  display: none;
}
//音量的控制条
video::-webkit-media-controls-volume-slider {
  display: none;
}
//所有控件
video::-webkit-media-controls-enclosure {
  display: none;
}
.bac-black {
  background-color: #00000010;
}
.bac-whie {
  background-color: #ffffff20;
}
</style>
